/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M2.09 11.6 0 18l6.24-2 .13-.09L17.46 4.82a1.45 1.45 0 0 0 .51-1.09 1.59 1.59 0 0 0-.52-1.1L15.37.5a1.59 1.59 0 0 0-1.11-.52 1.46 1.46 0 0 0-1.1.53Zm4.09 3.21-1.16-1.17 8.23-8.23 1.16 1.17Zm7.68-13.66a.52.52 0 0 1 .38-.21.67.67 0 0 1 .46.24l2.12 2.11a.69.69 0 0 1 .24.44.61.61 0 0 1-.25.45l-1.74 1.74-3-3Zm-2.44 2.44 1.16 1.16-8.23 8.23-1.16-1.16ZM5.36 15.31l-3.92 1.25 1.24-3.92Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'PencilIcon';

export default Icon;
